
/**
 * 委托竞卖合同信息维护
 */
import React, { Component } from 'react';
import { Modal, Form, Input, Row, Col, Switch, InputNumber, DatePicker } from 'antd';
import moment from 'moment';

import http from '../../../axios/http';
import validator from '../../../util/validator';
import Loading from '../../ui/Loading';

import messager from '../../ui/messager';

const fields = [{
    "text": "车辆保留价",
    "field": "reservePrice",
    "number": true,
    rules: [
        { required: true, message: '车辆保留价不能为空!' },
    ]
}, {
    "text": "竞价时间",
    "field": "auctionTime",
    "date": true,
    rules: [
        { required: true, message: '竞价时间不能为空!' },
    ]
}, {
    "text": "服务费",
    "field": "serviceCharge",
    "number": true,
}, {
    "text": "过户费",
    "field": "tradeCharge",
    "number": true,
}, {
    "text": "委托人姓名",
    "field": "clientName",
    "disabled": true
}, {
    "text": "委托人证件号",
    "field": "clientCreditNo",
    rules: [
        { required: true, message: '委托人证件号不能为空!' },
        validator.creditNo
    ]
}, {
    "text": "委托人电话",
    "field": "clientTel",
    rules: [
        { required: true, message: '委托人电话不能为空!' },
        validator.tel
    ]
}, {
    "text": "委托人地址",
    "field": "clientAddr",
    "textarea": true,
    "disabled": true,
    // rules: [
    //     { required: true, message: '委托人地址不能为空!' },
    //     { max: 64, message: '委托人地址不能超过64个字符！' },
    // ]
}, {
    "text": "是否代理人",
    "field": "agent",
    "radio": true,
}, {
    "text": "代理人姓名",
    "field": "agentName",
    "agent": true,
    rules: [
        { required: true, message: '代理人姓名不能为空!' },
        { max: 32, message: '代理人姓名不能超过32个字符！' },
    ]
}, {
    "text": "代理人证件号",
    "field": "agentCreditNo",
    "agent": true,
    rules: [
        { required: true, message: '代理人证件号不能为空!' },
        validator.creditNo
    ]
}, {
    "text": "代理人电话",
    "field": "agentTel",
    "agent": true,
    rules: [
        { required: true, message: '代理人电话不能为空!' },
        validator.tel
    ]
}];


class CommissionContractEditForm extends Component {

    state = {
        loadingVisible: false
    }

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            this.setState({ loadingVisible: true });
            let id = this.props.editData.id
            if (id !== undefined && id != null) {
                values["id"] = id;
            }
            values["vehicleId"] = this.props.editData["vehicleId"];
            values["clientName"] = this.props.editData["clientName"];

            if (values["auctionTime"] != null) {
                values["auctionTime"] = values["auctionTime"].format("YYYY-MM-DD HH:mm:ss");
            }

            values["agent"] = values["agent"] ? 1 : 0;

            http.post({
                url: '/auction/web/audit/saveContract',
                data: values,
                success: (res) => {
                    this.props.onCancel();
                    messager.notify("保存成功！");
                    this.props.successCallback();
                    this.setState({ loadingVisible: false });
                },
                error: (res) => {
                    messager.alert(res, "异常", "error");
                    this.setState({ loadingVisible: false });
                }
            });
        });
    };

    //swith选择改变时触发
    radioChange = (value) => {
        const { editData } = this.props;
        if (value) {
            editData.agent = 1;
        } else {
            editData.agent = 0;
        }
    }


    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            if (item.agent && editData["agent"] !== 1) {
                continue
            }
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: item.date ? (editData[item.field] == null || editData[item.field] === "" ? null : moment(editData[item.field]))
                                : item.radio ? editData[item.field] === 1
                                    : editData[item.field],
                            valuePropName: item.radio ? 'checked' : 'value'
                        })(
                            item.number ?
                                <InputNumber precision={0} min={0} max={99999999} style={{ width: '100%' }} />
                                : item.radio ? <Switch checkedChildren="是" unCheckedChildren="否" onChange={this.radioChange} />
                                    : item.date ? <DatePicker style={{ width: '100%' }} />
                                        : item.textarea ? <Input.TextArea disabled={item.disabled === true} />
                                            : <Input disabled={item.disabled} />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    create2Col = (fields) => {
        let dom = this.createDom(fields);
        let result = [];
        for (let i = 0; i < dom.length; i++) {
            let item = <Col key={i} span={11} offset={i % 2 === 0 ? 0 : 2}>{dom[i]}</Col>;
            result.push(item);
        }
        return result;
    }

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                width={900}
                visible={visible}
                title="委托竞卖合同信息维护"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    <Row>{this.create2Col(fields)}</Row>
                </Form>
                <Loading
                    visible={this.state.loadingVisible}
                    message="正在保存"
                />
            </Modal>
        );
    }
}

const CommissionContractEdit = Form.create()(CommissionContractEditForm);

export default CommissionContractEdit;